// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__91MIj {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.styles_successMessage__6yWeQ {
  background-color: rgba(0, 0, 0, 0.1333333333);
  padding: 62px 130px 70px;
  text-align: center;
  display: flex;
  align-items: center;
  place-items: baseline;
  gap: 10px;
  margin-bottom: 80px;
}
.styles_successMessage__6yWeQ span {
  display: inline;
}

.styles_eventCount__s3h3\\+ {
  font-size: 36px;
  font-weight: 500;
  color: #333;
}

.styles_messageText__3J9\\+n {
  font-size: 24px;
  color: #333;
}

.styles_calendarName__VcUmd {
  font-size: 28px;
  font-weight: 500;
  color: #333;
}

.styles_successTitle__oyjhX {
  font: var(--typography-h1);
  color: var(--color-black);
  margin: 0;
  padding: 0;
  line-height: 1.2;
}

.styles_successSubtitle__yZsTi {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
}

.styles_actionsContainer__cJ6-r {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.styles_appleButtonRow__BLQYD {
  width: 100%;
}

.styles_navigationButtonsRow__U6Zfz {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
}
@media (max-width: 640px) {
  .styles_navigationButtonsRow__U6Zfz {
    flex-direction: column;
  }
}

.styles_homepageButton__UbMRU,
.styles_coursesButton__lr0FQ {
  flex: 1 1;
  min-width: 0;
  position: relative;
  transition: all 0.2s ease;
}
@media (max-width: 640px) {
  .styles_homepageButton__UbMRU,
  .styles_coursesButton__lr0FQ {
    width: 100%;
  }
}

.styles_buttonTextContent__VA\\+Ph {
  transition: transform 0.2s ease;
}

.styles_buttonArrowLeft__0G5ZM,
.styles_buttonArrowRight__iX4RD {
  position: absolute;
  top: 50%;
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease, color 0.2s ease;
  display: flex;
  align-items: center;
}
.styles_buttonArrowLeft__0G5ZM svg,
.styles_buttonArrowRight__iX4RD svg {
  filter: none !important;
}

.styles_buttonArrowLeft__0G5ZM {
  left: 16px;
}

.styles_buttonArrowRight__iX4RD {
  right: 16px;
}

.styles_homepageButton__UbMRU:hover,
.styles_coursesButton__lr0FQ:hover {
  background-color: transparent !important;
  color: #4A90E2 !important;
  border-color: #4A90E2 !important;
}
.styles_homepageButton__UbMRU:hover .styles_buttonArrowLeft__0G5ZM,
.styles_homepageButton__UbMRU:hover .styles_buttonArrowRight__iX4RD,
.styles_coursesButton__lr0FQ:hover .styles_buttonArrowLeft__0G5ZM,
.styles_coursesButton__lr0FQ:hover .styles_buttonArrowRight__iX4RD {
  opacity: 1;
  color: #4A90E2;
}
.styles_homepageButton__UbMRU:hover .styles_buttonArrowLeft__0G5ZM svg,
.styles_homepageButton__UbMRU:hover .styles_buttonArrowRight__iX4RD svg,
.styles_coursesButton__lr0FQ:hover .styles_buttonArrowLeft__0G5ZM svg,
.styles_coursesButton__lr0FQ:hover .styles_buttonArrowRight__iX4RD svg {
  filter: none !important;
}
.styles_homepageButton__UbMRU:hover .styles_buttonArrowLeft__0G5ZM,
.styles_coursesButton__lr0FQ:hover .styles_buttonArrowLeft__0G5ZM {
  transform: translateY(-50%) translateX(0);
}
.styles_homepageButton__UbMRU:hover .styles_buttonArrowRight__iX4RD,
.styles_coursesButton__lr0FQ:hover .styles_buttonArrowRight__iX4RD {
  transform: translateY(-50%) translateX(0);
}
.styles_homepageButton__UbMRU:active,
.styles_coursesButton__lr0FQ:active {
  background-color: #2968C8 !important;
  color: white !important;
  border-color: #2968C8 !important;
}
.styles_homepageButton__UbMRU:active .styles_buttonArrowLeft__0G5ZM,
.styles_homepageButton__UbMRU:active .styles_buttonArrowRight__iX4RD,
.styles_coursesButton__lr0FQ:active .styles_buttonArrowLeft__0G5ZM,
.styles_coursesButton__lr0FQ:active .styles_buttonArrowRight__iX4RD {
  color: white;
}
.styles_homepageButton__UbMRU:active .styles_buttonArrowLeft__0G5ZM svg,
.styles_homepageButton__UbMRU:active .styles_buttonArrowRight__iX4RD svg,
.styles_coursesButton__lr0FQ:active .styles_buttonArrowLeft__0G5ZM svg,
.styles_coursesButton__lr0FQ:active .styles_buttonArrowRight__iX4RD svg {
  filter: none !important;
}

.styles_homepageButton__UbMRU:hover .styles_buttonTextContent__VA\\+Ph {
  transform: translateX(10px);
}

.styles_coursesButton__lr0FQ:hover .styles_buttonTextContent__VA\\+Ph {
  transform: translateX(-10px);
}

.styles_helpLink__OLr0I {
  background: none;
  border: none;
  color: #4285f4;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  margin-top: 12px;
  padding: 0;
}
.styles_helpLink__OLr0I:hover {
  color: #3367d6;
  text-decoration: none;
}
.styles_helpLink__OLr0I:focus {
  outline: 2px solid #4285f4;
  outline-offset: 2px;
}

/* Modal styling */
.styles_modalOverlay__1Ju7S {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.styles_modalContent__6OD3r {
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.styles_closeButton__VJBWP {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_closeButton__VJBWP:hover {
  color: #333;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.styles_modalTitle__6Ipu5 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.styles_modalSubtitle__U9CY5 {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #666;
}

.styles_modalSteps__VTrgZ {
  margin: 0;
}

.styles_modalStep__J3zTu {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
}
.styles_modalStep__J3zTu:first-child {
  margin-top: 0;
}
.styles_modalStep__J3zTu:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/screens/events-added/styles.module.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,6CAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,0BAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,sCAAA;EACA,kCAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AADF;AAIE;EAPF;IAQI,sBAAA;EADF;AACF;;AAIA;;EAEE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AADF;AAGE;EAPF;;IAQI,WAAA;EACF;AACF;;AAEA;EACI,+BAAA;AACJ;;AAEA;;EAEI,kBAAA;EACA,QAAA;EAEA,UAAA;EACA,mEAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAEI;;EACE,uBAAA;AACN;;AAOE;EACE,UAAA;AAJJ;;AAQE;EACE,WAAA;AALJ;;AAaE;;EACE,wCAAA;EACA,yBAAA;EACA,gCAAA;AATJ;AAWI;;;;EAEE,UAAA;EACA,cAAA;AAPN;AASM;;;;EACE,uBAAA;AAJR;AAQI;;EACE,yCAAA;AALN;AAQI;;EACE,yCAAA;AALN;AASE;;EACE,oCAAA;EACA,uBAAA;EACA,gCAAA;AANJ;AAQI;;;;EAEE,YAAA;AAJN;AAMM;;;;EACE,uBAAA;AADR;;AAQA;EACE,2BAAA;AALF;;AAQA;EACE,4BAAA;AALF;;AAQA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,UAAA;AALF;AAOE;EACE,cAAA;EACA,qBAAA;AALJ;AAQE;EACE,0BAAA;EACA,mBAAA;AANJ;;AAUA,kBAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAPF;;AAUA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAPF;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;AASE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAPJ;;AAWA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AARF;;AAWA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AARF;;AAWA;EACE,SAAA;AARF;;AAWA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AARF;AAUE;EACE,aAAA;AARJ;AAWE;EACE,gBAAA;AATJ","sourcesContent":["@import \"mixins\";\n.container {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.successMessage {\n  background-color: #00000022;\n  padding: 62px 130px 70px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  place-items: baseline;\n  gap: 10px;\n  margin-bottom: 80px;\n\n  span {\n    display: inline;\n  }\n}\n\n.eventCount {\n  font-size: 36px;\n  font-weight: 500;\n  color: #333;\n}\n\n.messageText {\n  font-size: 24px;\n  color: #333;\n}\n\n.calendarName {\n  font-size: 28px;\n  font-weight: 500;\n  color: #333;\n}\n\n.successTitle {\n  font: var(--typography-h1);\n  color: var(--color-black);\n  margin: 0;\n  padding: 0;\n  line-height: 1.2;\n}\n\n.successSubtitle {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n}\n\n.actionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.appleButtonRow {\n  width: 100%;\n}\n\n.navigationButtonsRow {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  width: 100%;\n  \n  // Stack vertically on mobile\n  @media (max-width: 640px) {\n    flex-direction: column;\n  }\n}\n\n.homepageButton,\n.coursesButton {\n  flex: 1;\n  min-width: 0; // Allow buttons to shrink if needed\n  position: relative;\n  transition: all 0.2s ease;\n  \n  @media (max-width: 640px) {\n    width: 100%;\n  }\n}\n\n.buttonTextContent {\n    transition: transform 0.2s ease;\n  }\n\n.buttonArrowLeft,\n.buttonArrowRight {\n    position: absolute;\n    top: 50%;\n    //transform: translateY(-50%);\n    opacity: 0;\n    transition: opacity 0.2s ease, transform 0.2s ease, color 0.2s ease;\n    display: flex;\n    align-items: center;\n\n    svg {\n      filter: none !important;  // Override the Button component's filter\n      //   width: 16px;\n      //   height: 16px;\n      //   fill: #999;\n      //   transition: fill 0.2s ease;\n    }\n  }\n  \n  .buttonArrowLeft {\n    left: 16px;\n    //transform: translateY(-50%) translateX(-8px);\n  }\n  \n  .buttonArrowRight {\n    right: 16px;\n    //transform: translateY(-50%) translateX(8px);\n  }\n\n\n// Hover effects for both navigation buttons\n.homepageButton,\n.coursesButton {\n  &:hover {\n    background-color: transparent !important;\n    color: #4A90E2 !important;\n    border-color: #4A90E2 !important;\n    \n    .buttonArrowLeft,\n    .buttonArrowRight {\n      opacity: 1;\n      color: #4A90E2;  // Make arrows blue on hover to match button text\n\n      svg {\n        filter: none !important;  // Ensure filter override on hover\n      }\n    }\n    \n    .buttonArrowLeft {\n      transform: translateY(-50%) translateX(0);\n    }\n    \n    .buttonArrowRight {\n      transform: translateY(-50%) translateX(0);\n    }\n  }\n  \n  &:active {\n    background-color: #2968C8 !important;\n    color: white !important;\n    border-color: #2968C8 !important;\n\n    .buttonArrowLeft,\n    .buttonArrowRight {\n      color: white;  // Match the button text color on active\n\n      svg {\n        filter: none !important;  // Ensure filter override on active\n      }\n    }\n  }\n}\n\n// Push text off-center on hover\n.homepageButton:hover .buttonTextContent {\n  transform: translateX(10px);\n}\n\n.coursesButton:hover .buttonTextContent {\n  transform: translateX(-10px);\n}\n\n.helpLink {\n  background: none;\n  border: none;\n  color: #4285f4;\n  cursor: pointer;\n  font-size: 14px;\n  text-decoration: underline;\n  margin-top: 12px;\n  padding: 0;\n  \n  &:hover {\n    color: #3367d6;\n    text-decoration: none;\n  }\n  \n  &:focus {\n    outline: 2px solid #4285f4;\n    outline-offset: 2px;\n  }\n}\n\n/* Modal styling */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.closeButton {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  &:hover {\n    color: #333;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n  }\n}\n\n.modalTitle {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.modalSubtitle {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n  color: #666;\n}\n\n.modalSteps {\n  margin: 0;\n}\n\n.modalStep {\n  margin: 8px 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #333;\n  \n  &:first-child {\n    margin-top: 0;\n  }\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__91MIj`,
	"successMessage": `styles_successMessage__6yWeQ`,
	"eventCount": `styles_eventCount__s3h3+`,
	"messageText": `styles_messageText__3J9+n`,
	"calendarName": `styles_calendarName__VcUmd`,
	"successTitle": `styles_successTitle__oyjhX`,
	"successSubtitle": `styles_successSubtitle__yZsTi`,
	"actionsContainer": `styles_actionsContainer__cJ6-r`,
	"appleButtonRow": `styles_appleButtonRow__BLQYD`,
	"navigationButtonsRow": `styles_navigationButtonsRow__U6Zfz`,
	"homepageButton": `styles_homepageButton__UbMRU`,
	"coursesButton": `styles_coursesButton__lr0FQ`,
	"buttonTextContent": `styles_buttonTextContent__VA+Ph`,
	"buttonArrowLeft": `styles_buttonArrowLeft__0G5ZM`,
	"buttonArrowRight": `styles_buttonArrowRight__iX4RD`,
	"helpLink": `styles_helpLink__OLr0I`,
	"modalOverlay": `styles_modalOverlay__1Ju7S`,
	"modalContent": `styles_modalContent__6OD3r`,
	"closeButton": `styles_closeButton__VJBWP`,
	"modalTitle": `styles_modalTitle__6Ipu5`,
	"modalSubtitle": `styles_modalSubtitle__U9CY5`,
	"modalSteps": `styles_modalSteps__VTrgZ`,
	"modalStep": `styles_modalStep__J3zTu`
};
export default ___CSS_LOADER_EXPORT___;
